/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ad_Avoid_Duplicates_LabelInputs */

const en_ad_avoid_duplicates_label = /** @type {(inputs: Ad_Avoid_Duplicates_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avoid duplicate descriptions`)
};

const fr_ad_avoid_duplicates_label = /** @type {(inputs: Ad_Avoid_Duplicates_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Évitez les descriptions en double.`)
};

const de_ad_avoid_duplicates_label = /** @type {(inputs: Ad_Avoid_Duplicates_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vermeiden Sie doppelte Beschreibungen`)
};

const it_ad_avoid_duplicates_label = /** @type {(inputs: Ad_Avoid_Duplicates_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Evita descrizioni duplicate`)
};

const ru_ad_avoid_duplicates_label = /** @type {(inputs: Ad_Avoid_Duplicates_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Избегайте дублирования описаний.`)
};

const es_ad_avoid_duplicates_label = /** @type {(inputs: Ad_Avoid_Duplicates_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Evite descripciones duplicadas.`)
};

const zh_cn2_ad_avoid_duplicates_label = /** @type {(inputs: Ad_Avoid_Duplicates_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`避免重复描述。`)
};

const ja_ad_avoid_duplicates_label = /** @type {(inputs: Ad_Avoid_Duplicates_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`重複した説明を避ける`)
};

const hi_ad_avoid_duplicates_label = /** @type {(inputs: Ad_Avoid_Duplicates_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`एक ही विवरण को दोहराने से बचें`)
};

const pt_pt2_ad_avoid_duplicates_label = /** @type {(inputs: Ad_Avoid_Duplicates_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Evite descrições duplicadas`)
};

/**
* | output |
* | --- |
* | "Avoid duplicate descriptions" |
*
* @param {Ad_Avoid_Duplicates_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ad_avoid_duplicates_label = /** @type {((inputs?: Ad_Avoid_Duplicates_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ad_Avoid_Duplicates_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_ad_avoid_duplicates_label(inputs)
	if (locale === "de") return de_ad_avoid_duplicates_label(inputs)
	if (locale === "it") return it_ad_avoid_duplicates_label(inputs)
	if (locale === "ru") return ru_ad_avoid_duplicates_label(inputs)
	if (locale === "es") return es_ad_avoid_duplicates_label(inputs)
	if (locale === "zh-CN") return zh_cn2_ad_avoid_duplicates_label(inputs)
	if (locale === "ja") return ja_ad_avoid_duplicates_label(inputs)
	if (locale === "hi") return hi_ad_avoid_duplicates_label(inputs)
	if (locale === "pt-PT") return pt_pt2_ad_avoid_duplicates_label(inputs)
	return en_ad_avoid_duplicates_label(inputs)
});